'use client';

import { Navigation } from '@/app/[locale]/components/Navigation/Navigation';
import { useNavigationTracking } from '@/hooks/tracking/useNavigationTracking';
import { useConfigurationApi } from '@/hooks/useConfigurationApi';
import { useCustomerApi } from '@/hooks/useCustomerApi';
import { useOfferToolUser } from '@/providers/OfferToolUserProvider/OfferToolUserProvider';
import { useParams } from 'next/navigation';

export const NavigationWrapper = () => {
  const { customerId, configurationId } = useParams<{
    customerId: string;
    configurationId: string;
  }>();
  const customerIdParsed = parseInt(customerId, 10);
  const configurationIdParsed = configurationId;
  const customerIdByQuery = useCustomerApi().getById(
    {
      customerId: customerIdParsed,
    },
    { enabled: !!customerIdParsed },
  );

  const customerName = customerIdByQuery.data
    ? `${customerIdByQuery.data?.firstName} ${customerIdByQuery.data?.lastName}`
    : '';

  const { user: currentUser } = useOfferToolUser();
  const { profilePhotoUrl } = currentUser ?? {};

  const { data: configuration } = useConfigurationApi().getById(
    { configurationHashId: configurationIdParsed },
    { enabled: !!configurationIdParsed },
  );

  const { trackNavigationItemClick } = useNavigationTracking({
    user: currentUser,
    configuration: configuration,
  });

  return (
    <>
      <Navigation
        customerName={customerName}
        customerId={customerId}
        configurationId={configurationIdParsed}
        profilePhotoUrl={profilePhotoUrl ?? undefined}
        onClickNavigationItem={trackNavigationItemClick}
      />
    </>
  );
};
